<template>
    <el-dialog :title="type === 'create' ? '批改作业' : '编辑批改内容'" width="860px" center :close-on-click-modal="false"
        :visible="isShowCorrectDialog" @close="closeCorrecting">
        <div class="work-reminder">
            <header>
                <img :src="baseinfo_correcting.user.photo" alt="">
                <span>{{ baseinfo_correcting.user.name }}</span>
                <span>{{ baseinfo_correcting.time }}</span>
            </header>
            <span>{{ baseinfo_correcting.content }}</span>
        </div>
        <!-- 评分 -->
        <el-rate :void-icon-class="icon1" :icon-classes="iconClasses" :colors="colors" v-model="score" show-text
            :texts="score_text"></el-rate>

        <div class="work-contanier">
            <div class="work-txt">
                <el-input ref="content" type="textarea" resize="none" class="work-content" maxlength="1000" :rows="12"
                    show-word-limit v-model="content" placeholder="点击输入评语..." />
                <text class="work-txt-length">{{ content.length }}/1000</text>
            </div>
            <upload-file :hasphotos="photos" :hasthumb="thumb_photos" :voice="audio" @addSource="addSource"></upload-file>
        </div>

        <div slot="footer">
            <el-button plain @click="closeCorrecting">取消</el-button>
            <el-button type="primary" @click="saveCorrect">完成</el-button>
        </div>
    </el-dialog>
</template>

<script>
import UploadFile from '../UploadFile.vue'
import "@/assets/iconfont/other/iconfont.css"
export default {
    components: { UploadFile },
    data () {
        return {
            icon1: 'iconfont icon-aixin',
            icon2: 'iconfont icon-aixin1',
            content: '',
            audio: '',
            photos: [],
            thumb_photos: [],
            score: 0, //得分
            iconClasses: ['iconfont icon-aixin1', 'iconfont icon-aixin1', 'iconfont icon-aixin1'],
            colors: ['#FD5A39', '#FD5A39', '#FD5A39'],
            score_text: ['良', '良+', '优', '优+', '优++'],
        }
    },
    props: {
        isShowCorrectDialog: [Boolean],
        baseinfo_correcting: [Object],
        type: {
            type: String,
            default: 'create'
        },
        work_id: [String, Number]
    },

    mounted () {
        if (this.type === 'edit') {
            const { correct: { content, images, score, thumbs, voice } } = this.baseinfo_correcting
            this.photos = images
            this.thumb_photos = thumbs
            this.audio = voice
            this.content = content
            this.score = score
        }
    },

    methods: {
        closeCorrecting () {
            this.$emit('closeCorrecting')
        },

        // 添加资源
        addSource (data) {
            const file = data
            if (file.type === 'img') {
                const { thumb_photos, photos } = file
                this.thumb_photos = thumb_photos
                this.photos = photos
            } else {
                const { audio } = file
                this.audio = audio
                this.isShowAudioPlayer = true
            }
        },

        async saveCorrect () {
            if (!this.content) {
                this.$message.warning('请输入批改内容')
                this.$refs.content.focus()
                return
            }

            const score = this.score_text[this.score - 1]

            let data = {
                score: score,
                content: this.content,
                images: this.photos.join(','),
                thumbs: this.thumb_photos.join(','),
                voice_length: 0,
                voice_play_length: 0,
                voice: this.audio,
            }


            if (this.type === 'create') {
                const type1 = { work_id: this.work_id, feedback_id: this.baseinfo_correcting.id }
                data = { ...data, ...type1 }
            } else {
                const type2 = { correct_id: this.baseinfo_correcting.id }
                data = { ...data, ...type2 }
            }
            const url = this.type === 'create' ? 'base/homework/correct/create' : 'base/homework/correct/update'
            const { data: res } = await this.$axios.post(url, data)
            if (res.errCode === 0) {
                this.$message.success("编辑成功")
                this.$store.dispatch('setHouseworkStatus', true)
                this.$emit('updateHousework')
            } else {
                this.$message.error(res.message)
            }
        },

    }
}
</script>

<style lang="scss" scoped>
@import '../../../../../assets/css/housework.scss';

.work-reminder {
    padding: 20px 16px;
    box-sizing: border-box;
    background: #F5F7F8;

    header {
        width: 100%;
        display: flex;
        align-items: center;
        // flex-direction:row;
        // justify-content: flex-start;
        font-size: 16px;
        color: #262C31;

        img {
            width: 16px;
            height: 16px;
            border-radius: 50%;
        }

        span {
            &:nth-child(2) {
                margin: 0 8px;
            }

            &:nth-child(3) {
                margin-top: auto;
                font-size: 12px;
                color: #A5A5A5;
            }
        }
    }

    >span {
        display: inline-block;
        margin-top: 10px;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #62666A;
    }

}

/deep/ .el-rate {
    margin: 30px 0;
    text-align: center;
    cursor: pointer;

    i {
        font-size: 32px;
    }
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/housework/components/teacher/HouseworkCorrecting.vue